//import customSelect from 'custom-select'
/************************************************
 Number Field Input plus - minus Arrows funcional
 ************************************************/
// Save the input value to sessionStorage
const saveInputValue = (input, key) => {
  const inputValue = input.value
  if (inputValue) {
    sessionStorage.setItem(key, inputValue)
  }
}

const onLoadSetFieldsForChildrenAndPersons = () => {
  let prrsonInputFields = document.getElementById('field_16_3')
  let prrsonInputValue = ''
  if (prrsonInputFields) {
    prrsonInputValue =
      prrsonInputFields.getElementsByTagName('input').length / 2
  }
  let nuberOfPersons = document.getElementById('input_16_1')
  if (nuberOfPersons) {
    nuberOfPersons.value = prrsonInputValue
  }
  if (prrsonInputFields) {
    if (prrsonInputFields.getElementsByTagName('input').length > 3) {
      prrsonInputFields.classList.remove('hide')
    }
  }
  let field_16_16 = document.getElementById('field_16_16')
  let inputsLenght = ''
  if (field_16_16) {
    inputsLenght = field_16_16.getElementsByTagName('input').length
  }
  console.log(inputsLenght)
  if (inputsLenght > 4) {
    let ins2 = field_16_16.getElementsByTagName('input').length / 4
    let input_16_15 = document.getElementById('input_16_15')
    if (input_16_15) {
      input_16_15.value = ins2
    }
    if (field_16_16) {
      if (field_16_16.getElementsByTagName('input').length > 3) {
        field_16_16.classList.remove('hide')
      }
    }
  }
}

// Load the input value from sessionStorage
const loadInputValue = (inputId, key) => {
  const storedValue = sessionStorage.getItem(key)
  if (storedValue) {
    document.getElementById(inputId).value = storedValue
  }
}

// Modify the plus-minus functionality to save the value
const plusMinus = () => {
  let plusses = document.getElementsByClassName('plus'),
    minuses = document.getElementsByClassName('minus')

  if (plusses.length > 0) {
    for (let i = 0; i < plusses.length; i++) {
      let input = plusses[i].parentNode.getElementsByTagName('input')[0]
      let key = input.id === 'input_16_1' ? 'numberOfPersons' : 'numberOfKids'
      plusses[i].addEventListener('click', () => {
        let inputValue = parseInt(input.value) || 0
        input.value = inputValue + 1
        minuses[i].classList.remove('disabled')
        saveInputValue(input, key)
      })
    }
  }

  if (minuses.length > 0) {
    for (let i = 0; i < minuses.length; i++) {
      let input = minuses[i].parentNode.getElementsByTagName('input')[0]
      let key = input.id === 'input_16_1' ? 'numberOfPersons' : 'numberOfKids'
      if (parseInt(input.value) === 0) minuses[i].classList.add('disabled')

      minuses[i].addEventListener('click', () => {
        let inputValue = parseInt(input.value) || 0
        if (inputValue > 1) {
          input.value = inputValue - 1
          minuses[i].classList.remove('disabled')
        } else {
          input.value = 0
          minuses[i].classList.add('disabled')
        }
        saveInputValue(input, key) // Save value after decrement
      })
    }
  }
}

/**********************************************************************
 Add or remove new list row by increaing number field value with + or -
 **********************************************************************/
const addPerson = (container, list, calcOneLess, zeroValue) => {
  let inputContainer = document.getElementsByClassName(container),
    teilnehmerList = document.getElementsByClassName(list),
    listTitle = document.getElementsByClassName('list-title')
  //
  if (inputContainer.length && teilnehmerList.length && listTitle.length) {
    let input = inputContainer[0].getElementsByTagName('input')
    //set to default 1 value
    if (input.length) input[0].value = zeroValue ? 0 : 1
    //
    let plus = inputContainer[0].getElementsByClassName('plus'),
      minus = inputContainer[0].getElementsByClassName('minus'),
      addButton = teilnehmerList[0].getElementsByClassName('add_list_item'),
      removeButton = teilnehmerList[0].getElementsByClassName(
        'delete_list_item'
      )
    //add new person
    if (plus.length && addButton.length) {
      plus[0].addEventListener('click', () => {
        if (calcOneLess) {
          if (parseInt(input[0].value) === 2) {
            teilnehmerList[0].classList.remove('hide')
            listTitle[0].classList.remove('hide')
          } else if (parseInt(input[0].value) > 2) {
            addButton[0].click()
          } else {
            return
          }
        } else {
          if (parseInt(input[0].value) === 1) {
            teilnehmerList[0].classList.remove('hide')
          } else {
            addButton[0].click()
          }
        }
        if (list == 'kids-repeater') {
          setTimeout(() => {
            //EnableSelects()
            EnableCheckboxex()
          }, 1000)
        }
      })
    }
    //remove person
    if (minus.length && removeButton.length) {
      minus[0].addEventListener('click', () => {
        if (calcOneLess) {
          if (parseInt(input[0].value) === 1) {
            teilnehmerList[0].classList.add('hide')
            listTitle[0].classList.add('hide')
            minus[0].classList.add('disabled')
          } else if (parseInt(input[0].value) > 1) {
            minus[0].classList.remove('disabled')
            removeButton[0].click()
          } else {
            input[0].value = 1
            teilnehmerList[0].classList.add('hide')
            listTitle[0].classList.add('hide')
            return
          }
        } else {
          if (parseInt(input[0].value) === 0) {
            teilnehmerList[0].classList.add('hide')
          } else {
            removeButton[0].click()
          }
        }
      })
    }
  }
}

const EnableCheckboxex = () => {
  let childcare = document.getElementsByClassName('childcare')
  if (childcare.length) {
    for (let i = 0; i < childcare.length; i++) {
      let randomId = 'id-' + Math.random().toString().slice(2, 10)
      childcare[i].id = randomId
      childcare[i].nextSibling.htmlFor = randomId
      childcare[i].addEventListener('click', e => {
        e.target.previousSibling.value = e.target.checked ? 'Ja' : 'Nein'
      })
    }
  }
}

/************************************
 Trigger Click Evnt on Checkbox Image
 ************************************/
const EnableCheckboxexImagesClick = () => {
  let imagesContainers = document.getElementsByClassName(
    'checkbox-image__container'
  )
  if (imagesContainers.length) {
    for (let i = 0; i < imagesContainers.length; i++) {
      //add click on image
      imagesContainers[i].addEventListener('click', e => {
        let checkboxInput = e.target
          .closest('.gfield')
          .getElementsByTagName('input')
        //swtich checked status
        if (checkboxInput.length) {
          checkboxInput[0].checked = checkboxInput[0].checked ? false : true
        }
      })
    }
  }
}

/************************************************
 Raumprogramm List functional for Multistep Form
 ************************************************/
const EnableRaumprogrammList = () => {
  const radioButtons = document.querySelectorAll(
    '.raumprogramm-list-radio input[type="radio"]'
  )

  // Standardmäßig die Liste verstecken
  let list = document.getElementsByClassName('raumprogramm-list')
  if (list.length) {
    list[0].classList.add('hidden')
  }

  radioButtons.forEach(radio => {
    radio.addEventListener('change', event => {
      let rList = window.tag001_global_data.raumprogramm,
        list = document.getElementsByClassName('raumprogramm-list')
      const groups = list[0]?.querySelectorAll('.gfield_list_group') || []
      const listIsAlreadyFilled = groups.length === 1

      if (event.target.value === 'Nein' && event.target.checked) {
        if (list.length && rList.length && listIsAlreadyFilled) {
          list[0].classList.add('loading')
          list[0].classList.add('visible')
          list[0].classList.remove('hidden')

          // clear list first
          ClearList()
          setTimeout(() => {
            // add new list components through custom button
            customAddButtonFunction()
            // fill list
            FillList(rList)
            // calculating summary first time
            CalcSummary()
          }, rList.length * 100)
          setTimeout(() => {
            // add checkboxes like functional to last columns
            // EnableListRowInputCheckbox()
            document
              .getElementsByClassName('raumprogramm-list')[0]
              .classList.remove('loading')
          }, rList.length * 200)
        }
        // Zeigt die Liste an
        if (list.length) {
          list[0].classList.add('visible')
          list[0].classList.remove('hidden')
          CalcSummary()
        }
      } else if (event.target.value === 'Ja' && event.target.checked) {
        // Versteckt die Liste, wenn "Ja" ausgewählt wird
        if (list.length) {
          list[0].classList.add('hidden')
          list[0].classList.remove('visible')
        }
      }
    })
  })
}

//clear list functional on load
const ClearList = () => {
  let itemsGroup = document.getElementsByClassName('gfield_list_group')
  //delete all rows except first
  for (let i = 1; i < itemsGroup.length; i++) {
    setTimeout(() => {
      itemsGroup[itemsGroup.length - 1]
        .getElementsByClassName('delete_list_item')[0]
        .click()
    }, 50)
  }
}

//add new list item custom button functional
const customAddButtonFunction = () => {
  let raumprogrammList = document.getElementsByClassName('raumprogramm-list'),
    addButton = document.getElementsByClassName('add-list-button'),
    plus = raumprogrammList[0].getElementsByClassName('add_list_item')
  if (addButton.length) {
    //add new list row
    if (plus.length && addButton.length) {
      addButton[0].addEventListener('click', () => {
        plus[plus.length - 1].click()
        //get last element from lit-groups and add keyup listener to it
        let updatedRows = raumprogrammList[0].getElementsByClassName(
            'gfield_list_group'
          ),
          lastAddedRowInputs = updatedRows[
            updatedRows.length - 1
          ].getElementsByTagName('input')
        //fill first input with defaylt text
        lastAddedRowInputs[0].value = 'Weiterer Raum'
        //add keyup listener to 3rd input for calculatimg sum
        lastAddedRowInputs[2].addEventListener('keyup', () => {
          CalcSummary()
        })
        //re enable checkbox functional
      })
    }
  }
}

//fill list with data from global data
const FillList = rList => {
  //add amount rows we need to the list
  for (let i = 0; i < rList.length - 1; i++) {
    setTimeout(() => {
      let raumprogrammList = document.getElementsByClassName(
          'raumprogramm-list'
        ),
        pluses = raumprogrammList[0].getElementsByClassName('add_list_item')
      pluses[pluses.length - 1].click()
    }, 100)
  }
  //fill all rows
  for (let i = 0; i < rList.length; i++) {
    let raumprogrammList = document.getElementsByClassName('raumprogramm-list')
    setTimeout(() => {
      //get all rows
      const Rows = raumprogrammList[0].querySelectorAll('.gfield_list_group')
      //console.log({ Rows }) //eslint-disable-line
      Rows[i].classList.add('prefilled')
      //get current row inputs
      let rowInputs = Rows[i]?.getElementsByTagName('input')
      //fill current row inputs
      if (rowInputs) {
        rowInputs[0].value = rList[i].wohnraume
        rowInputs[1].value = rList[i].durchschnitt
        rList[i].ihr_bedarf_geschatzt
          ? (rowInputs[2].value = rList[i].ihr_bedarf_geschatzt)
          : (rowInputs[2].placeholder = 'm²')
        rowInputs[2].addEventListener('keyup', () => {
          CalcSummary()
        })

        rowInputs[0].setAttribute('tabindex', '-1')
        rowInputs[1].setAttribute('tabindex', '-1')
      }
    }, (rList.length / 2) * 100)
  }
}

//calculating summary function
const CalcSummary = () => {
  // Check for list on page
  let raumprogrammList = document.getElementsByClassName('raumprogramm-list')
  if (raumprogrammList.length) {
    // Get all list rows
    let summaryRows = raumprogrammList[0].getElementsByClassName(
        'gfield_list_group'
      ),
      sum = 0
    // Calculate sum
    if (summaryRows.length) {
      for (let i = 0; i < summaryRows.length; i++) {
        // Get all row inputs
        let summaryInputs = summaryRows[i].getElementsByTagName('input')
        // Check if 3rd column input has value and add it to summary
        if (parseInt(summaryInputs[2].value)) {
          sum += parseInt(summaryInputs[2].value)
        }
      }
      // Add sum to inputs
      let zwischensummeInputContainer = document.getElementsByClassName(
          'zwischensumme'
        ),
        flureTreppenInputContainer = document.getElementsByClassName(
          'flure-treppen'
        ),
        gesamtbedarfInputContainer = document.getElementsByClassName(
          'gesamtbedarf'
        )
      //
      if (zwischensummeInputContainer.length) {
        let zwischensummeInput = zwischensummeInputContainer[0].getElementsByTagName(
          'input'
        )
        zwischensummeInput[0].value = parseInt(sum) ? sum + ' m²' : ''
      }
      if (flureTreppenInputContainer.length) {
        let flureTreppenInput = flureTreppenInputContainer[0].getElementsByTagName(
          'input'
        )
        flureTreppenInput[0].value = parseInt(sum)
          ? (sum * 0.1).toFixed(2) + ' m²'
          : ''
      }
      if (gesamtbedarfInputContainer.length) {
        let gesamtbedarfInput = gesamtbedarfInputContainer[0].getElementsByTagName(
          'input'
        )
        gesamtbedarfInput[0].value = parseInt(sum)
          ? (sum + sum * 0.1).toFixed(2) + ' m²'
          : ''
      }
    }
  }
}

// Add event listener to recalculate summary when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
  /********************************************************
   Enable Gravity Froms Functional for List, Checkboxes etc
   *******************************************************/
  let form = document.getElementsByClassName('gform_wrapper')
  if (form.length) {
    jQuery(document).on('gform_post_render', function () {
      EnableCheckboxex()
      EnableCheckboxexImagesClick()
      //multi step form list functional
      EnableRaumprogrammList()
      //disable fields that has disable class
      const disabledElements = document.querySelectorAll('.disabled')
      disabledElements.forEach(element => {
        element.setAttribute('disabled', 'disabled')
      })
    })
    //check if we need to display list on page load or prev-next form page change
    jQuery(document).on('gform_page_loaded', function () {
      let list = document.getElementsByClassName('raumprogramm-list')
      const radioButtons = document.querySelectorAll(
        '.raumprogramm-list-radio input[type="radio"]'
      )
      if (radioButtons.length > 0 && list.length > 0) {
        radioButtons.forEach(radio => {
          if (radio.checked && radio.value === 'Nein') {
            list[0].classList.add('visible')
            list[0].classList.remove('hidden')
          }
        })
      }
    })
  }
  //plus & minus number field value
  plusMinus()
  //add listener to lists for add or delete rows
  addPerson('teilnehmer-list-add', 'teilnehmer-list', true, false)
  addPerson('kids-repeater-add', 'kids-repeater', false, true)
  CalcSummary()
  loadInputValue()
  onLoadSetFieldsForChildrenAndPersons()
})
